export default __webpack_public_path__ + "static/media/mic_off.8d318284.svg";